/**
 * Form-values → API payload mapping for 施術師毎CSV出力 (SCR-046).
 */

import type { MassagerCsvSearchParams } from './types';
import { normalizeYearmonth } from '@/utils/dateConverter';

export interface MassagerCsvSearchFormValues {
  searchVisitmonth: string; // YYYYMM
  serialNumber: string;
  massagerId: number | null;
  rezeptKbn: '1' | '2';
  sortRadio: '1' | '2' | '3' | '4';
}

export function formValuesToSearchPayload(
  values: MassagerCsvSearchFormValues
): MassagerCsvSearchParams {
  const payload: MassagerCsvSearchParams = {
    search_visitmonth: normalizeYearmonth(values.searchVisitmonth) ?? values.searchVisitmonth,
    rezept_kbn: values.rezeptKbn,
    sort_radio: values.sortRadio,
  };
  
  if (values.serialNumber.trim() !== '') {
    payload.serial_number = values.serialNumber.trim();
  }
  
  if (values.massagerId != null) {
    payload.massager_id = values.massagerId;
  }
  
  return payload;
}

